//
// Copyright (c) 2025 Comcast
//

import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useSearchParams, createSearchParams } from 'react-router'
import { useTranslation } from 'react-i18next'

import * as sessionUserSelector from 'selectors/sessionUser'

import {
  RouteTicketsSearchResults,
  RouteTicketProviderTicketsSearchResults,
} from 'routes'

import Search from 'components/Shared/Search/Index'

const StyledWrapper = styled.div`
  height: 24px;
  margin-right: 8px;
`

const GlobalSearch = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const isUserPrivileged = useSelector(sessionUserSelector.isUserPrivileged)

  let pathname = RouteTicketsSearchResults()

  const isSearchResultsPage = location.pathname === pathname
  const searchValue = isSearchResultsPage ? (searchParams.get('search') || '') : ''

  if (isUserPrivileged) {
    pathname = RouteTicketProviderTicketsSearchResults()
  }

  const onSubmit = (newSearchValue) => {
    if (newSearchValue) {
      navigate({
        pathname: pathname,
        search: `?${createSearchParams({ search: newSearchValue })}`,
      })
    } else if (searchValue) {
      navigate({ pathname: '/' })
    }
  }

  return (
    <StyledWrapper>
      <Search
        key={searchValue}
        initialValue={searchValue}
        onChange={onSubmit}
        placeholder={t('mainHeader.searchPlaceholder')}
        withHotKeys
      />
    </StyledWrapper>
  )
}

export default GlobalSearch
